export {
  default as greatSunlight,
  ReactComponent as GreatSunlight,
} from '@assets/icons/features-and-amenities/great-sunlight.svg'    
